import React, { Component } from "react";

class AvailableData extends Component {
  state = {
    data: [],
    control: null,
    loaded: false,
  };

  constructor(props) {
    super(props);

    this.createDataList = this.createDataList.bind(this);
  }

  componentDidMount() {
    this.setState({
      control: this.props.control,
      loaded: true,
      data: this.props.data,
    });
  }

  createDataList() {
    let output = [];
    this.state.data.map((itm, idx) => {
      output.push(
        <div className="more-links" key={idx}>
          {itm.modal.component}
          <a
            className="item  addCursorPointer"
            id="activatePass215"
            data-pass-id="215"
            data-purchase-group-id="GRPSRV00041"
          ></a>
        </div>
      );
    });
    return (
      <div className="home-links">
        <div className="hold ">
          <div className="more-hold">
            <div className="more-title more-title-bar">
              <table cellPadding="0" cellSpacing="0" height="100%">
                <tbody>
                  <tr>
                    <td valign="middle" className="selection-message"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            {output}
            <div className="more-title">
              <table cellPadding="0" cellSpacing="0" height="100%">
                <tbody>
                  <tr>
                    <td valign="middle">
                      <span className="customeClassSideMessageNoMBs">
                        Για να ξεκινήσεις το σερφάρισμα ενεργοποίησε εδώ το
                        πακέτο που θέλεις:
                      </span>
                      {/*<span class="customeClassSideMessageNoMBs">Για να σερφάρεις στο Internet ενεργοποίησε εδώ το πακέτο που σου ταιριάζει:</span>*/}
                      <span className="customeClassSideMessageAvailableMBs customDisplayNone">
                        Για περισσότερο σερφάρισμα ενεργοποίησε εδώ το πακέτο
                        που θέλεις:
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="clear"></div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.loaded) {
      return this.createDataList();
    } else {
      return "";
    }
  }
}

export default AvailableData;
